import SlideItem from './slide-item'
export default SlideItem
